import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import FaqHero from './components/FaqHero';
import FaqAccordion from './components/FaqAccordion';
import ContactCTA from './components/ContactCTA';

const FaqPage = () => {
  useEffect(() => {
    document.title = 'Preguntas Frecuentes - Vaciado y Limpieza | JUSTCLEAN Castelldefels';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Resuelve tus dudas sobre vaciado de pisos, limpieza Diógenes, precios, plazos y servicios en Castelldefels. Respuestas a preguntas frecuentes.');
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "¿Cuánto cuesta un vaciado de piso en Castelldefels?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "El precio de un vaciado de piso en Castelldefels depende de varios factores: tamaño del inmueble, cantidad de enseres a retirar, estado de limpieza, accesibilidad y servicios adicionales requeridos. Realizamos una visita gratuita para evaluar el trabajo y ofrecerte un presupuesto detallado sin compromiso. De media, un vaciado completo de piso puede oscilar entre 400€ y 1.500€, pero cada caso es único."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cuánto tiempo tarda el servicio de vaciado?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "El tiempo necesario depende del tamaño del inmueble y la cantidad de enseres. Un piso estándar de 2-3 habitaciones suele tardar entre 4 y 8 horas. Pisos más grandes o casos de acumulación extrema pueden requerir 1-3 días. En casos urgentes, podemos movilizar más personal para acelerar el proceso. Te informamos del tiempo estimado en el presupuesto."
          }
        },
        {
          "@type": "Question",
          "name": "¿Qué hacen con los residuos y muebles retirados?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Gestionamos todos los residuos de forma legal y responsable. Los muebles y enseres en buen estado los donamos a entidades sociales y ONG. Los materiales reciclables los llevamos a puntos limpios autorizados. Los residuos no aprovechables se transportan a vertederos legales. Te entregamos certificado de gestión de residuos si lo necesitas."
          }
        },
        {
          "@type": "Question",
          "name": "¿Ofrecen servicio discreto para casos delicados?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí, la discreción es una de nuestras prioridades, especialmente en casos de síndrome de Diógenes, desahucios o situaciones familiares delicadas. Nuestro equipo trabaja con uniformes neutros, vehículos sin rotulación llamativa y máxima confidencialidad. Respetamos los horarios que prefieras y adaptamos nuestro trabajo a tus necesidades de privacidad."
          }
        },
        {
          "@type": "Question",
          "name": "¿Trabajan con comunidades de vecinos y administradores de fincas?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí, colaboramos habitualmente con administradores de fincas, comunidades de vecinos e inmobiliarias en Castelldefels y comarca. Ofrecemos condiciones especiales para profesionales con necesidades recurrentes. Nos encargamos de vaciados de pisos abandonados, trasteros comunitarios y limpieza de zonas comunes. Emitimos facturas y certificados necesarios para la gestión administrativa."
          }
        },
        {
          "@type": "Question",
          "name": "¿Tienen servicio de urgencia 24 horas?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí, ofrecemos servicio de urgencia disponible 24 horas al día, 7 días a la semana, incluidos festivos. Si necesitas un vaciado o limpieza urgente en Castelldefels, llámanos al 602 36 59 96 y movilizaremos un equipo lo antes posible. Entendemos que algunas situaciones requieren respuesta inmediata y estamos preparados para atenderlas."
          }
        },
        {
          "@type": "Question",
          "name": "¿El presupuesto es realmente sin compromiso?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí, totalmente. Realizamos una visita gratuita a tu inmueble en Castelldefels o alrededores, evaluamos el trabajo necesario y te entregamos un presupuesto detallado sin ningún compromiso por tu parte. No tienes que contratar el servicio si el presupuesto no se ajusta a tus necesidades. Solo cobramos si decides contratarnos y el precio final será exactamente el presupuestado."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cubren toda el área del Baix Llobregat?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí, ofrecemos nuestros servicios en Castelldefels y toda la comarca del Baix Llobregat Sud, incluyendo Gavà, Viladecans, El Prat de Llobregat, Sant Boi, Sitges y la zona sur de Barcelona. También atendemos localidades cercanas. Si tu ubicación no está en la lista, contáctanos y te informaremos sobre la disponibilidad de nuestros servicios en tu zona."
          }
        }
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-20">
        <FaqHero />
        <FaqAccordion />
        <ContactCTA />
      </div>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
};

export default FaqPage;
